module.exports = __webpack_public_path__ + "static/2019-park-a6b01b1d71fac228d11ed4f4f3e6c7d4.jpg";